module.exports = __webpack_public_path__ + "img/farm_tech_Normal_ua.1db43846.webp";